import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import { get } from "@/vue/api/api";
//modules
import { bps } from "./modules/bps.js";
import { porting } from "./modules/porting.js";
import { updateext } from "./modules/updateext.js";
import { emailstatus } from "./modules/emailstatus.js";
import { autoattendant } from "./modules/autoattendant.js";
import { lae } from "./modules/lae.js";
import { smsaudit } from "./modules/smsaudit";
import { addresses } from "@/vue/store/modules/addresses";
import { pbxes } from "@/vue/store/modules/pbxes";
import { licenses } from "@/vue/store/modules/licenses";
import { EVENT_TYPES, triggerEvent } from "@/events";
import { oktaAxios } from "@/vue/api/config";
import { parseJwt, PRODUCTION } from "@/vue/utils/helper";

var ENUMS = require("@/vue/assets/enums.json");
var REGEX = require("@/vue/assets/pattern_def.json");

const sessionStorage = createPersistedState({
  storage: window.localStorage,
  paths: ["user", "customer", "updateext.selectedExtensionProperty"],
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    customer: {},
    sideNavOpen: true,
    enums: ENUMS,
    regex: REGEX,
  },
  mutations: {
    SET_SIDE_NAV_OPEN: (state, payload) => {
      state.sideNavOpen = payload;
    },
    SET_USER: (state, payload) => {
      state.user = payload;
    },
    SET_CUSTOMER: (state, payload) => {
      state.customer = payload;
      triggerEvent(EVENT_TYPES.SYNC_CUSTOMER, payload);
    },
  },
  actions: {
    setUser: ({ commit }, payload) => {
      commit("SET_USER", payload);
    },
    setSideNavOpen: ({ commit }, payload) => {
      commit("SET_SIDE_NAV_OPEN", payload);
    },
    fetchCustomer: ({ commit }, payload) => {
      return oktaAxios
        .post(`/v1/customers/${payload.customerId}/token`)
        .then((response) => {
          let token = response.data.token;
          let cust = parseJwt(token);
          Vue.prototype.$http.defaults.headers.common["token"] = token;
          Vue.prototype.$smphttp.defaults.headers.common["Authorization"] =
            "Bearer " + token;

          cust.accessToken = token;
          cust.customerName = payload.customerName;
          cust.pbx = payload.pbx;
          cust.pbxList = payload.pbxList;
          cust.adminList = payload.adminList;
          cust.platform = payload.platform;
          cust.tenantInfo = payload.tenantInfo;

          commit("SET_CUSTOMER", cust);
          console.debug(`[React Sync Flow] Vue customer set.`, cust);
          payload.success("Customer " + payload.customerName + " selected!");
        })
        .catch((error) => {
          payload.error(error.message);
        });
    },
    clearCustomer: ({ commit }) => {
      commit("SET_CUSTOMER", {});
    },
    async searchCustomers(
      { commit },
      { platform, searchField, searchTerm, config = {} }
    ) {
      let encodedSearchTerm = encodeURIComponent(searchTerm);
      platform ||= PRODUCTION;

      if (searchField === "tenantName") {
        const customerByTenant = await oktaAxios
          .get(`/v1/tenants/${encodedSearchTerm}/customer`, config)
          .then(({ data }) => (data?.length ? data[0] : null));
        searchField = "customerId";
        encodedSearchTerm = customerByTenant?.customerId;
      }

      const filter = searchField === "customerId" ? "customerId" : "name";
      const path = searchField === "pbxName" ? "pbxes" : "customers";

      const data = await get(
        `/v1/${platform}/${path}/admin?filter=${filter}==*${encodedSearchTerm}*`,
        `/v1/${path}/admin?filter=${filter}==*${encodedSearchTerm}*`,
        config
      );

      return data.data;
    },
    async findAndFetchCustomer(
      { dispatch },
      { platform, searchField, searchTerm }
    ) {
      const [customer] = await dispatch("searchCustomers", {
        platform,
        searchField,
        searchTerm,
      });
      return new Promise((resolve, reject) => {
        dispatch("fetchCustomer", {
          platform,
          login: customer.adminLoginList[0],
          pbx: customer.pbxList[0],
          pbxList: customer.pbxList,
          adminList: customer.adminLoginList,
          customerName: customer.customerName,
          tenantInfo: customer.tenantInfo,
          success: resolve,
          error: reject,
        });
      });
    },
  },
  getters: {
    getUser: (state) => state.user,
    getCustomer: (state) => state.customer,
    isSideNavOpen: (state) => state.sideNavOpen,
    getEnums: (state) => state.enums,
    getEnum: (state) => (resourceName) =>
      state.enums.content.find((e) => e.resourceName === resourceName),
    getRegex: (state) => state.regex,
  },
  modules: {
    addresses,
    bps,
    porting,
    updateext,
    emailstatus,
    autoattendant,
    lae,
    smsaudit,
    pbxes,
    licenses,
  },
  plugins: [sessionStorage],
});
